import { Fragment } from 'react';
import { OrderStepsIndicatorStyle } from '../../styles/components/order-process';

export interface IOrderStep {
  id: number;
  name: string;
  label: string;
}

export interface IOrderStepsIndicatorProps {
  steps: IOrderStep[];
  currentStep: number;
}
const OrderStepsIndicator = (props: IOrderStepsIndicatorProps) => {
  return (
    <div className={OrderStepsIndicatorStyle['order-process-steps']}>
      {props.steps.map((step, index) => (
        <Fragment key={index}>
          <div
            className={`${OrderStepsIndicatorStyle['order-process-step']} ${
              step.id === props.currentStep &&
              OrderStepsIndicatorStyle['is-active']
            }`}>
            <div
              className={
                OrderStepsIndicatorStyle['order-process-step-indicator']
              }>
              {index + 1}
            </div>
            <span
              className={OrderStepsIndicatorStyle['order-process-step-label']}>
              {step.label}
            </span>
          </div>
          <div
            className={OrderStepsIndicatorStyle['order-process-divider']}></div>
        </Fragment>
      ))}
    </div>
  );
};

export default OrderStepsIndicator;
